import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { ContactActionPanel } from '../contactActionPanel';
import { MatchInfo } from './matchInfo';
import { ContactAvatar } from './components/contactAvatar';

export const ContactInfo = ({
  queryParams,
  contact,
  type,
  page,
  match,
  matchListInfo,
  scoreDetails,
  list,
  onClickHighlight,
  deleteContactFromList,
  fullContactView,
  addedToSharedList,
  trackPageEvent,
  showJobSeeking,
}) => (
  <>
    <Flex flexGrow={[0, 0, 1]} flexDirection="column">
      <ContactAvatar
        onClickHighlight={onClickHighlight}
        variant="large"
        type={type}
        contact={contact}
        highlighted={match.highlighted}
        trackLinkedinClick={() => trackPageEvent('contacts:view_linkedin_profile')}
        showEmailDropdown={type !== 'public'}
        showJobSeeking={showJobSeeking}
      />

      {['default', 'matches', 'public'].includes(type) && (
        <Box flex="0 0 auto" mt="48px">
          {type === 'matches' && (
            <MatchInfo
              match={match}
              matchListInfo={matchListInfo}
              scoreDetails={scoreDetails}
              onClickHighlight={onClickHighlight}
            />
          )}
          <ContactActionPanel
            type={type}
            page={page}
            queryParams={queryParams}
            contact={contact}
            matchId={match?.id}
            list={list}
            actions={type === 'public' ? ['show-importers'] : ['add-importer', 'lists', 'tags']}
            deleteContactFromList={deleteContactFromList}
            fullContactView={fullContactView}
            addedToSharedList={addedToSharedList}
          />
        </Box>
      )}
    </Flex>
  </>
);

ContactInfo.propTypes = {
  queryParams: PropTypes.object,
  contact: PropTypes.object,
  type: PropTypes.oneOf(['default', 'read', 'matches', 'public']),
  page: PropTypes.string,
  match: PropTypes.object,
  matchListInfo: PropTypes.object,
  scoreDetails: PropTypes.object,
  list: PropTypes.object,
  onClickHighlight: PropTypes.func,
  deleteContactFromList: PropTypes.bool,
  fullContactView: PropTypes.bool,
  addedToSharedList: PropTypes.bool,
  trackPageEvent: PropTypes.func.isRequired,
  showJobSeeking: PropTypes.bool,
};

ContactInfo.defaultProps = {
  queryParams: {},
  contact: {},
  type: 'default',
  page: '',
  match: {},
  matchListInfo: {},
  scoreDetails: {},
  list: null,
  onClickHighlight: null,
  deleteContactFromList: false,
  fullContactView: false,
  addedToSharedList: false,
  showJobSeeking: false,
};
